import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { Item, Tools } from '../../../../models'

@Component({
  selector: 'app-write-off-form-com',
  templateUrl: './write-off-form.com.html'
})

export class WriteOffFormComponent implements OnInit {

  @Input() item: Item = null
  @Output() event = new EventEmitter()
  model = {
    reasons: ['滞销', '瑕疵', '损毁'],
    selDate: new Tools().beijingDate()
  }
  form = null

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    if (this.item) {
      this.buildForm()
    }
  }

  public submit(e) {
    e.preventDefault()
    const data = {
      item_id: this.item.item_id,
      count: this.item.count,
      date: this.form.value.date,
      write_off_count: this.form.value.write_off_count,
      reason: this.form.value.reason
    }
    this.event.emit({ source: 'write-off-form', action: 'submit', data: data })
  }

  public cancel(e) {
    e.preventDefault()
    this.event.emit({ source: 'write-off-form', action: 'cancel' })
  }

  private buildForm() {
    this.form = this.fb.group({
      write_off_count: [1, Validators.required],
      date: [this.model.selDate, Validators.required],
      reason: [this.model.reasons[0], Validators.required]
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/forms/write-off-form/write-off-form.com.ts